import React, { ReactNode } from 'react';

/**
 * Compound modal footer component.
 *
 * On desktop (≥640px): primary right, secondary left, side-by-side, content-width.
 * On mobile (<640px):  primary on top, secondary below, full-width stacked.
 *
 * Use as `footer={<ModalFooter><ModalFooter.Secondary>Cancel</ModalFooter.Secondary>
 *                  <ModalFooter.Primary>Save</ModalFooter.Primary></ModalFooter>}`.
 *
 * Slots are CSS-ordered, so authoring order doesn't matter — primary always lands
 * on the right (desktop) / top (mobile).
 *
 * Replaces the slab-pattern footer (two stacked `btn-physical-block` buttons).
 */

interface ModalFooterProps {
    children: ReactNode;
    className?: string;
}

interface SlotProps {
    children: ReactNode;
}

const ModalFooterRoot: React.FC<ModalFooterProps> & {
    Primary: React.FC<SlotProps>;
    Secondary: React.FC<SlotProps>;
    Extra: React.FC<SlotProps>;
} = ({ children, className }) => (
    <div className={`modal-footer-v2${className ? ` ${className}` : ''}`}>
        {children}
    </div>
);

const Primary: React.FC<SlotProps> = ({ children }) => (
    <div className="modal-footer-v2__primary">{children}</div>
);

const Secondary: React.FC<SlotProps> = ({ children }) => (
    <div className="modal-footer-v2__secondary">{children}</div>
);

const Extra: React.FC<SlotProps> = ({ children }) => (
    <div className="modal-footer-v2__extra">{children}</div>
);

ModalFooterRoot.Primary = Primary;
ModalFooterRoot.Secondary = Secondary;
ModalFooterRoot.Extra = Extra;

export default ModalFooterRoot;
